import { updateUserSession } from "../store/actions/userActions";
import { errorManagement } from "../utils/errorManagement";
import { getConfigVariable } from "./config";

const refreshToken = async (refreshTokenProps, apiDomain) => {
    const { dispatch, user } = refreshTokenProps || {};
    try {
        if (!dispatch || !user) {
            return false;
        }

        if (!user?.session) {
            return false;
        }

        const queriesBody = {
            query: `query($u:String!){refresh_token(token:$u)}`,
            variables: {
                u: user.session,
                userJwtToken: user.session,
            },
        };
        const response = await fetch(apiDomain + "/graphql", {
            method: "POST",
            credentials: apiDomain ? "include" : "same-origin",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(queriesBody),
        });
        const { data } = await response.json();
        const { refresh_token } = data;

        refresh_token && dispatch(updateUserSession(refresh_token));
        return true;
    } catch (error) {
        //TODO: fix catch error when api are down?
        return false;
    }
};

export async function fetchApi(url = "/graphql", body, config = {}, extraOptions) {
    const userJwtToken = extraOptions?.user?.session;
    const apiDomain = getConfigVariable("REACT_APP_PROXY_HOST");
    if (body?.variables) {
        body.variables = { ...body.variables, userJwtToken: userJwtToken };
    } else {
        body.variables = { userJwtToken: userJwtToken };
    }

    const response = await fetch(apiDomain + url, {
        method: extraOptions?.method || "POST",
        credentials: apiDomain ? "include" : "same-origin",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        ...config,
        ...(!extraOptions?.method && { body: JSON.stringify(body) }),
    });

    if (response.headers.get("X-Token-Renewal") === "true") {
        await refreshToken(
            { dispatch: extraOptions?.dispatch, user: extraOptions?.user },
            apiDomain,
        );
    }

    try {
        const errors = await response.clone().json();
        errorManagement(errors, { dispatch: extraOptions?.dispatch, locale: extraOptions?.locale });
    } catch (error) {
        //TODO: fix catch error when cant do the errorManagement
    }

    return response;
}
